import GetDynamicFormPayloadRequestModelBase from '../_generated/modelBases/get-dynamic-form-payload-request-model-base';

export default class GetDynamicFormPayloadRequestModel extends GetDynamicFormPayloadRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
